module.exports = __webpack_public_path__ + "img/digitalocean.4afb3858.svg";